import React from 'react';
import { Modal } from 'react-bootstrap';
import BillingoDocumentFlow from './BillingoDocumentFlow';

// Modal host for the reusable flow, used by the standalone launch points
// (order details, payments). In the wizard the flow is embedded directly.
//
// `billingo-document-modal` is how the E2E flows address THIS modal: it opens
// fullscreen over Order Details, which stays in the DOM, so a bare
// `.modal.show` selector can land on either one. Same reason
// `.order-details-modal` exists.
function BillingoDocumentModal({
  show, onHide, context, onComplete = () => {},
}) {
  return (
    <Modal show={show} onHide={onHide} fullscreen backdrop="static" scrollable className="billingo-document-modal">
      <Modal.Header closeButton>
        <Modal.Title>Create Billingo document</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {show && (
          <BillingoDocumentFlow
            context={context}
            onComplete={(doc) => { onComplete(doc); onHide(); }}
            onCancel={onHide}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}

export default BillingoDocumentModal;
